import styled from "styled-components";


export const Container = styled.section`
  margin-top: 15rem;
  
  h2{
    text-align: center;
    font-size: 4rem;
    margin-bottom: 3rem;
  }
  .projects{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: 2rem;
    padding: 1rem;
    overflow: hidden;

    .project{
      padding: 2rem 1.8rem;
      background-color: #2b2b2b;
      border-radius: 1.2rem;
      transition: 0.25s;
      display: flex;
      flex-direction: column;
      height: 100%;
      color: #FFF;
      cursor: pointer;
      &:hover, &:active{
        transform: translateY(-5px);
        background-color: var(--green);
        footer {
          .tech-list {
            opacity: 1;
            color: #ffffff;
          }
        }
      }

      header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--blue);
        margin-bottom: 3.6rem;
        .project-links{
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        a > img {
          width: 5.0rem;
        }
      }
      
      h3{
        margin-bottom: 2rem;
      }

      p{
        letter-spacing: 0.12rem;
        margin-bottom: 2rem;
        a{
          color: #FFFF;
          border-bottom: 1px solid var(--green);
          transition: color 0.25s;
          &:hover{
            color: var(--green);
          }
        }
      }

      footer{
        margin-top: auto;
        .tech-list{
          display: flex;
          align-items: center;
          gap: 2rem;
          font-size: 1.4rem;
          opacity: 0.6;
          transition: opacity 0.2s, color 0.2s;
          li{ color: #ffffff; }
        }
      }

    }
  }

  @media (max-width: 960px){
    margin-top: 10rem;

    h2 {
      font-size: 3.2rem;
    }

    .projects{
      grid-template-columns: 1fr 1fr;
      gap: 1.6rem;
    }
  }

  @media (max-width: 740px){
    margin-top: 8rem;

    h2 {
      font-size: 2.8rem;
      margin-bottom: 2rem;
    }

    .projects{
      grid-template-columns: 1fr;
      gap: 1.4rem;
      padding: 0 1rem;
    }
  }

  @media (max-width: 480px){
    margin-top: 6rem;

    h2 {
      font-size: 2.4rem;
      margin-bottom: 1.6rem;
    }

    .projects{
      padding: 0 0.6rem;
      gap: 1.2rem;

      .project{
        padding: 1.6rem 1.4rem;

        header{
          margin-bottom: 2rem;

          a > img {
            width: 3.8rem;
          }
        }

        h3 {
          font-size: 1.6rem;
          margin-bottom: 1.2rem;
        }

        p {
          font-size: 1.4rem;
          letter-spacing: 0.08rem;
          margin-bottom: 1.4rem;
        }

        footer {
          .tech-list {
            gap: 1rem;
            font-size: 1.2rem;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
`